// extracted by mini-css-extract-plugin
module.exports = {"titleWrapper":"style_titleWrapper__1yPDh","rowsWrapper":"style_rowsWrapper__MzIkD","rowWrapper":"style_rowWrapper__2nir4","text":"style_text__wAX4o"};